import React, { Component } from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
export function Hero() {
  const {
    t,
    language
  } = useLanguage();
  return <section className="relative overflow-hidden" data-id="element-236">
      {/* Stacked layout for all screen sizes */}
      <div data-id="element-237">
        <div className="relative w-full" data-id="element-238">
          <img src="https://cdn.magicpatterns.com/uploads/oX7GpXWKPzy1ZrqAFy2gGv/lorena_imagen.png" alt="Lorena Beauty House Spa" className="w-full h-auto object-contain" data-id="element-239" />
          {/* Gradient fade at bottom of banner */}
          <div className="absolute bottom-0 left-0 right-0 h-24 sm:h-32 xl:h-40 bg-gradient-to-t from-beige-light via-beige-light/70 to-transparent" data-id="element-240"></div>
        </div>
        <div className="relative bg-beige-light px-6 pb-12 sm:px-8 sm:pb-14 lg:px-16 lg:pb-16 -mt-4" data-id="element-241">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="max-w-lg lg:max-w-5xl mx-auto text-center" data-id="element-242">
            <h1 className="text-3xl sm:text-4xl lg:text-6xl font-serif font-bold text-dark leading-tight mb-6" data-id="element-243">
              {t('hero', 'title1')}{' '}
              <span className="text-gold italic lg:not-italic" data-id="element-244">
                {t('hero', 'titleHighlight')}
              </span>
            </h1>
            <div className="border-l-[3px] border-gold pl-4 mb-8 text-left inline-block lg:mx-auto lg:max-w-3xl" data-id="element-245">
              <p className="text-base sm:text-lg lg:text-2xl text-dark/60 font-light leading-relaxed" data-id="element-246">
                {t('hero', 'subtitle')}
              </p>
            </div>
            <div data-id="element-247">
              <motion.a whileHover={{
              scale: 1.05
            }} whileTap={{
              scale: 0.95
            }} href={`https://wa.me/13472648498?text=${encodeURIComponent(language === 'es' ? 'Hola Lorena, me gustaría agendar una cita.' : 'Hi Lorena, I would like to book an appointment.')}`} target="_blank" rel="noopener noreferrer" className="inline-block bg-gold hover:bg-gold-dark text-white text-center px-8 py-4 rounded-sm font-medium text-lg transition-colors shadow-lg" data-id="element-248">
                {t('hero', 'cta')}
              </motion.a>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}